module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique no link a seguir: "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(".\n              ")])], 1)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _vm._l((this.listaTipoClassificacao), function(lista, index) {
    return _c('v-layout', {
      key: lista[0].tipoClassificacao,
      attrs: {
        "row": "",
        "wrap": "",
        "justify-space-between": ""
      }
    }, [_c('v-flex', [(lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || _vm.desabilitaClassificacoes(lista[0].classificacaoItem)) ? _c('v-text-field', {
      attrs: {
        "label": lista[0].tipoClassificacao,
        "prepend-icon": "dashboard",
        "readonly": "",
        "max-height": "400"
      },
      model: {
        value: (_vm.listaClassificacoesDoProjeto[index].descricao),
        callback: function($$v) {
          _vm.$set(_vm.listaClassificacoesDoProjeto[index], "descricao", $$v)
        },
        expression: "listaClassificacoesDoProjeto[index].descricao"
      }
    }) : _c('v-select', {
      attrs: {
        "label": lista[0].tipoClassificacao,
        "items": lista,
        "item-text": "descricao",
        "item-value": "id",
        "return-object": "",
        "prepend-icon": "dashboard",
        "max-height": "400",
        "required": "",
        "readonly": lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || _vm.desabilitaClassificacoes(lista[0].classificacaoItem),
        "autocomplete": ""
      },
      model: {
        value: (_vm.listaClassificacoesDoProjeto[index]),
        callback: function($$v) {
          _vm.$set(_vm.listaClassificacoesDoProjeto, index, $$v)
        },
        expression: "listaClassificacoesDoProjeto[index]"
      }
    })], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarClassificacoes(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarClassificacoes(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658628fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-classificacao.vue
// module id = 519
// module chunks = 0